
export class ReimbursementRequest {

    public firstName = "";
    public lastName = "";
    public contractNumber = "";
    public reimbursementType = ""

    public addressLine1 = "";
    public addressLine2 = "";
    public city = "";
    public state = "";
    public zip = "";
    public phoneNumber = "";
    public customerConcern = "";

}